/**
 * Sacbe Ibiza: dynamic cart callouts (A–D, G), PDP redundant pass notice (G), calendar bulk add.
 */
(function () {
  const cfg = () => window.SACBE_IBIZA || {};
  const DAY_PASS_HANDLES = new Set([
    'day-night-pass',
    'night-pass',
    'morning-pass',
    'love-academy-night-mose-facesoul-jun-18',
    'above-guided-symphonic-experience-june-22-night-pass',
  ]);

  function addonHandleSet() {
    const c = cfg();
    const fromCol = c.addonHandlesFromCollection;
    if (fromCol && fromCol.length) return new Set(fromCol);
    return new Set(c.fallbackAddonHandles || []);
  }

  function passHandleSet() {
    const c = cfg();
    const fromCol = c.passHandlesFromCollection;
    if (fromCol && fromCol.length) return new Set(fromCol);
    return new Set(c.fallbackPassHandles || []);
  }

  function roomHandleSet() {
    const c = cfg();
    const r = c.roomHandles;
    if (r && r.length) return new Set(r);
    return new Set();
  }

  function classifyLine(handle, roomSet, passSet, addonSet) {
    if (roomSet.has(handle)) return 'room';
    if (handle === 'week-pass') return 'week';
    if (addonSet.has(handle)) return 'addon';
    if (DAY_PASS_HANDLES.has(handle)) return 'day_pass';
    if (passSet.has(handle)) return 'day_pass';
    return 'other';
  }

  function analyzeCart(cart) {
    const roomSet = roomHandleSet();
    const passSet = passHandleSet();
    const addonSet = addonHandleSet();
    let hasRoom = false;
    let hasWeek = false;
    let hasDayPass = false;
    let hasAddon = false;

    for (const item of cart.items || []) {
      const h = item.handle;
      const kind = classifyLine(h, roomSet, passSet, addonSet);
      if (kind === 'room') {
        hasRoom = true;
      } else if (kind === 'week') {
        hasWeek = true;
      } else if (kind === 'day_pass') {
        hasDayPass = true;
      } else if (kind === 'addon') {
        hasAddon = true;
      }
    }

    return { hasRoom, hasWeek, hasDayPass, hasAddon };
  }

  function cartHasBoatLine(cart) {
    return (cart.items || []).some((i) => i.handle === 'boat-experience' && i.quantity > 0);
  }

  function cartHasHikeLine(cart) {
    return (cart.items || []).some((i) => (i.handle === 'coastal-hike' || i.handle === 'hike-atlantis') && i.quantity > 0);
  }

  function cartHasRoomLine(cart) {
    const roomSet = roomHandleSet();
    return (cart.items || []).some((i) => roomSet.has(i.handle) && i.quantity > 0);
  }

  function pickCartCalloutId(cart) {
    const { hasRoom, hasWeek, hasDayPass, hasAddon } = analyzeCart(cart);
    const strings = cfg().callouts || {};
    if (!cart.items || cart.items.length === 0) return null;
    if (cartHasRoomLine(cart) && (cartHasBoatLine(cart) || cartHasHikeLine(cart))) {
      return { id: 'H', tone: 'yellow', text: strings.H };
    }
    if (hasRoom) return { id: 'A', tone: 'green', text: strings.A };
    if (hasAddon && (hasWeek || hasDayPass)) return { id: 'D', tone: 'green', text: strings.D };
    if (hasWeek && !hasRoom) return { id: 'B', tone: 'green', text: strings.B };
    if (hasDayPass && !hasWeek && !hasRoom) return { id: 'C', tone: 'yellow', text: strings.C };
    return null;
  }

  function renderIntoSlot(el, payload) {
    if (!el) return;
    el.classList.remove('sacbe-callout', 'sacbe-callout--green', 'sacbe-callout--yellow', 'sacbe-callout--red', 'sacbe-callout--blue');
    if (!payload || !payload.text) {
      el.innerHTML = '';
      el.hidden = true;
      return;
    }
    el.classList.add('sacbe-callout', 'sacbe-callout--' + payload.tone);
    el.innerHTML = payload.text;
    el.hidden = false;
  }

  function updateCalloutsFromCart(cart) {
    const cartPayload = pickCartCalloutId(cart);

    document.querySelectorAll('[data-sacbe-context="cart"]').forEach((slot) => {
      renderIntoSlot(slot, cartPayload);
    });

    document.querySelectorAll('[data-sacbe-context="solstice"]').forEach((slot) => {
      renderIntoSlot(slot, null);
    });

    updatePdpG(cart);
  }

  function updatePdpG(cart) {
    const slot = document.getElementById('sacbe-pdp-g-slot');
    if (!slot) return;
    const pi = document.querySelector('product-info');
    const handle =
      slot.dataset.productHandle || (pi && pi.dataset.sacbeProductHandle) || '';
    const strings = cfg().callouts || {};
    if (!DAY_PASS_HANDLES.has(handle)) {
      slot.hidden = true;
      slot.innerHTML = '';
      return;
    }
    const { hasRoom, hasWeek } = analyzeCart(cart);
    const roomSet = roomHandleSet();
    let redundant = hasWeek || hasRoom;
    if (!redundant) {
      for (const item of cart.items || []) {
        if (item.handle === 'week-pass' || roomSet.has(item.handle)) {
          redundant = true;
          break;
        }
      }
    }
    if (redundant) {
      slot.className = 'sacbe-callout sacbe-callout--yellow sacbe-pdp-redundant';
      slot.innerHTML = strings.G || '';
      slot.removeAttribute('hidden');
      slot.style.display = '';
    } else {
      slot.setAttribute('hidden', '');
      slot.style.display = 'none';
      slot.innerHTML = '';
    }
  }

  /** True when the full cart page (not drawer-only) is showing — line items need a reload after AJAX add. */
  function isMainCartPage() {
    return Boolean(document.querySelector('#MainContent cart-items'));
  }

  async function refreshCartState() {
    try {
      const res = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
      const cart = await res.json();
      updateCalloutsFromCart(cart);
    } catch (e) {
      console.warn('Sacbe cart refresh failed', e);
    }
  }

  async function confirmIncludedAddonIfRoomInCart(btn) {
    const h = btn.dataset.sacbeAddonHandle;
    if (h !== 'boat-experience' && h !== 'coastal-hike' && h !== 'hike-atlantis') return true;
    try {
      const res = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
      const cart = await res.json();
      if (!cartHasRoomLine(cart)) return true;
      const c = cfg();
      const msg =
        h === 'boat-experience'
          ? c.boatRoomConfirmPlain || ''
          : c.hikeRoomConfirmPlain || '';
      return window.confirm(msg || 'This may already be included with your room. Add anyway?');
    } catch {
      return true;
    }
  }

  function bindAddonButtons() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('.product-sacbe-addons__atc');
      if (!btn || btn.disabled) return;
      const id = btn.dataset.variantId;
      if (!id) return;
      if (!(await confirmIncludedAddonIfRoomInCart(btn))) return;
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        });
        const data = await res.json();
        if (data.status) {
          window.alert(data.description || data.message || 'Could not add to cart');
          return;
        }
        if (isMainCartPage()) {
          window.location.reload();
          return;
        }
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sacbe-addon', cartData: data });
        }
        await refreshCartState();
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      } catch (err) {
        console.warn(err);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function bindPubSub() {
    if (typeof subscribe !== 'function') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(refreshCartState, 0);
    });
  }

  function initCalendarDemo() {
    const root = document.querySelector('[data-sacbe-calendar-demo]');
    if (!root) return;
    const stickyTotal = root.querySelector('[data-sacbe-calendar-total]');
    const modeInputs = root.querySelectorAll('input[name="sacbe-calendar-mode"]');
    const addBtn = root.querySelector('[data-sacbe-calendar-add-all]');

    function selectedVariantIds() {
      const ids = [];
      root.querySelectorAll('input[type="checkbox"][data-variant-id]:checked').forEach((cb) => {
        ids.push(Number(cb.dataset.variantId));
      });
      return ids;
    }

    function updateTotalCents() {
      let cents = 0;
      root.querySelectorAll('input[type="checkbox"][data-variant-id]:checked').forEach((cb) => {
        cents += Number(cb.dataset.priceCents || 0);
      });
      if (stickyTotal) {
        const ib = window.SACBE_IBIZA || {};
        const mf = ib.moneyFormatWithCurrency || ib.moneyFormat;
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney && mf) {
          stickyTotal.textContent = Shopify.formatMoney(cents, mf);
        } else {
          const iso = ib.currencyIsoCode || 'USD';
          stickyTotal.textContent = `${(cents / 100).toFixed(2)} ${iso}`;
        }
      }
    }

    root.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"]')) updateTotalCents();
    });

    modeInputs.forEach((inp) =>
      inp.addEventListener('change', () => {
        const full = inp.value === 'full';
        root.querySelectorAll('[data-sacbe-addon-only]').forEach((row) => {
          row.style.display = full ? '' : 'none';
        });
        root.querySelectorAll('[data-sacbe-addon-only] input').forEach((cb) => {
          if (!full) cb.checked = false;
        });
        updateTotalCents();
      })
    );

    addBtn?.addEventListener('click', async () => {
      const ids = selectedVariantIds();
      if (!ids.length) return;
      const boatSlot = window.__SACBE_ADDON_SLOTS && window.__SACBE_ADDON_SLOTS.boat;
      const hikeSlot = window.__SACBE_ADDON_SLOTS && window.__SACBE_ADDON_SLOTS.hike;
      const boatVid = boatSlot && boatSlot.id != null ? Number(boatSlot.id) : null;
      const hikeVid = hikeSlot && hikeSlot.id != null ? Number(hikeSlot.id) : null;
      const batchHasBoat = boatVid != null && !Number.isNaN(boatVid) && ids.includes(boatVid);
      const batchHasHike = hikeVid != null && !Number.isNaN(hikeVid) && ids.includes(hikeVid);
      if (batchHasBoat || batchHasHike) {
        try {
          const resCart = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
          const cart = await resCart.json();
          if (cartHasRoomLine(cart)) {
            const c = cfg();
            let msg = '';
            if (batchHasBoat && batchHasHike) msg = c.roomConfirmBoatAndHikePlain || '';
            else if (batchHasBoat) msg = c.boatRoomConfirmPlain || '';
            else msg = c.hikeRoomConfirmPlain || '';
            if (!window.confirm(msg || 'Continue?')) return;
          }
        } catch {
          /* proceed */
        }
      }
      addBtn.disabled = true;
      try {
        const items = ids.map((id) => ({ id, quantity: 1 }));
        const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await res.json();
        if (data.status && data.message) {
          window.alert(data.message);
          return;
        }
        if (isMainCartPage()) {
          window.location.reload();
          return;
        }
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sacbe-calendar', cartData: data });
        }
        await refreshCartState();
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      } finally {
        addBtn.disabled = false;
      }
    });

    updateTotalCents();
  }

  function loveAcademySellingTier() {
    const cfg = window.__SACBE_LOVE_ACADEMY_CONFIG || {};
    const n = parseInt(cfg.sellingTier, 10);
    return Number.isFinite(n) && n > 0 ? n : 4;
  }

  function selectLoveAcademySellingTierOnPdp() {
    const pi = document.querySelector('product-info');
    const handle = (pi && pi.dataset.sacbeProductHandle) || '';
    if (handle !== 'love-academy-night-mose-facesoul-jun-18') return;

    const tierNum = loveAcademySellingTier();
    const tierRe = new RegExp('tier\\s*' + tierNum, 'i');
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const radios = variantSelects.querySelectorAll('fieldset input[type="radio"]');
    for (const input of radios) {
      if (!tierRe.test(input.value || '')) continue;
      if (input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const selects = variantSelects.querySelectorAll('select');
    for (const select of selects) {
      for (const opt of select.options) {
        if (!tierRe.test(opt.textContent || opt.value || '')) continue;
        if (select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindPubSub();
    bindAddonButtons();
    refreshCartState();
    initCalendarDemo();
    selectLoveAcademySellingTierOnPdp();
  });
})();
